import React, { useState } from 'react';
import { motion } from 'framer-motion';
import copy from 'copy-to-clipboard';
import Layout from '../components/Layout';
import Textarea from '../components/Textarea';
import Button from '../components/Button';
import { sortLines } from '../utils/textUtils';

const LineSorter: React.FC = () => {
  const [text, setText] = useState('');
  const [result, setResult] = useState('');
  const [showToast, setShowToast] = useState(false);

  const handleSort = (type: keyof typeof sortLines) => {
    const sorted = sortLines[type](text);
    setResult(sorted);
  };

  const handleCopy = () => {
    copy(result);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  return (
    <Layout showBackButton>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32"
        >
          <h1 className="text-4xl font-bold text-textPrimary mb-8">줄 정렬</h1>
          <p className="text-textSecondary">
            여러 줄을 원하는 방식으로 정렬
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-24"
        >
          <label className="block text-textSecondary mb-8 text-sm">
            정렬할 텍스트 (한 줄에 하나씩)
          </label>
          <Textarea
            value={text}
            onChange={setText}
            placeholder="banana&#10;apple&#10;cherry"
          />
        </motion.div>

        {text && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-24"
          >
            <div className="flex flex-wrap gap-12 mb-24">
              <Button onClick={() => handleSort('ascending')}>
                오름차순
              </Button>
              <Button onClick={() => handleSort('descending')}>
                내림차순
              </Button>
              <Button onClick={() => handleSort('reverse')}>
                줄 반전
              </Button>
              <Button onClick={() => handleSort('shuffle')}>
                랜덤 섞기
              </Button>
            </div>

            {result && (
              <div>
                <label className="block text-textSecondary mb-8 text-sm">
                  정렬된 텍스트
                </label>
                <Textarea value={result} onChange={setResult} />
                <div className="mt-12">
                  <Button onClick={handleCopy}>결과 복사</Button>
                </div>
              </div>
            )}
          </motion.div>
        )}

        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="fixed bottom-32 left-1/2 transform -translate-x-1/2 bg-textPrimary text-white px-24 py-12 rounded-medium shadow-lg"
          >
            ✓ 복사됨
          </motion.div>
        )}
      </div>
    </Layout>
  );
};

export default LineSorter;
